import React, { createContext, useState } from 'react';
export const AlertContext = createContext({
    activeAlert: null,
    closeAlert: () => { },
    alert: () => { },
});
export const AlertContextProvider = ({ children }) => {
    const [activeAlert, setActiveAlert] = useState(null);
    let timeout = null;
    const close = () => {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        setActiveAlert(null);
    };
    const alert = (alertData) => {
        setActiveAlert(alertData);
        if (alertData.timeout) {
            timeout = setTimeout(close, alertData.timeout);
        }
    };
    return (React.createElement(AlertContext.Provider, { value: { activeAlert, closeAlert: close, alert } }, children));
};
